import { ATTRIBUTE_TYPE } from '../../../HelperMethods/FormUtils';

const SCHEMA_CONSTANTS = {
  id: {
    displayName: 'ID',
    path: 'id',
    type: ATTRIBUTE_TYPE.STRING,
    hide: true,
  },
  name: {
    displayName: 'Vendor Name',
    path: 'name',
    type: ATTRIBUTE_TYPE.STRING,
    isMandatory: true,
  },
  dba: {
    displayName: 'DBA',
    path: 'dba',
    type: ATTRIBUTE_TYPE.STRING,
  },
  aclAttribute: {
    displayName: 'ACL Attribute',
    path: 'aclAttribute',
    type: ATTRIBUTE_TYPE.STRING,
  },
  aclApproved: {
    displayName: 'ACL Approved',
    path: 'aclApproved',
    type: ATTRIBUTE_TYPE.CHECKBOX,
  },
  vendorNumber: {
    displayName: 'vendor Number',
    path: 'vendorNumber',
    type: ATTRIBUTE_TYPE.STRING,
  },
  customAttributes: {
    path: 'customAttributes',
  },
};

export default SCHEMA_CONSTANTS;
